import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import pp from "../../src/assets/img/profile.jpg";
import { useSelector } from "react-redux";
const AdminUserDetailPage = () => {
  const auth = useSelector((state) => state.auth);
  const users = useSelector((state) => state.users);
  const [activeTab, setActiveTab] = useState("Orders");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">User Informations</h5>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          {/* <button className="btn btn-warning">Print</button> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="user-view">
                    <div className="user-info">
                      <div
                        className="user-avatar"
                        style={{ textAlign: "center" }}
                      >
                        <br />
                        <img src={pp} alt="User Avatar" />
                      </div>
                      <br />
                      <div className="user-details">
                        <h3>Basic Informations</h3>
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <strong>Name:</strong>{" "}
                          <span>
                            {users?.customerDetails?.firstName +
                              " " +
                              users?.customerDetails?.lastName}
                          </span>
                        </p>
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <strong>Email:</strong>{" "}
                          <span>{users?.customerDetails?.email}</span>
                        </p>
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <strong>Contact No:</strong>{" "}
                          <span>{users?.customerDetails?.phone}</span>
                        </p>
                      </div>
                      <div
                        className="user-stats"
                        style={{
                          borderRight: "2px solid #ddd !important",
                        }}
                      >
                        <div>
                          <h5
                            style={{
                              display: "flex",
                              borderRight: "2px solid #ddd !important",
                            }}
                          >
                            Orders
                          </h5>
                          <span>2</span>
                        </div>
                        <div>
                          <h5 style={{ display: "flex" }}>Address</h5>
                          <span>0</span>
                        </div>
                        <div>
                          <h5 style={{ display: "flex" }}>Reviews</h5>
                          <span>0</span>
                        </div>
                      </div>
                    </div>
                    <div className="user-orders">
                      <div className="tabs">
                        <div
                          className={`tab ${
                            activeTab === "Orders" ? "active" : ""
                          }`}
                          onClick={() => handleTabClick("Orders")}
                        >
                          Orders
                        </div>
                        <div
                          className={`tab ${
                            activeTab === "Address" ? "active" : ""
                          }`}
                          onClick={() => handleTabClick("Address")}
                        >
                          Address
                        </div>
                        <div
                          className={`tab ${
                            activeTab === "Reviews" ? "active" : ""
                          }`}
                          onClick={() => handleTabClick("Reviews")}
                        >
                          Reviews
                        </div>
                      </div>

                      {/* Content for Orders */}
                      {activeTab === "Orders" && (
                        <>
                          <div className="order">
                            <h4>Order #3142</h4>
                            <ul>
                              <li>
                                Aashirwad aatta - 10 kg 450 $ <span>X 3</span>
                              </li>
                              <li>
                                Aer Aer Pocket - Bathroom Air Fragrance - 10
                                grams 143 $ <span>X 1</span>
                              </li>
                              <li>
                                Air tight glass container - 1 pcs 200 ${" "}
                                <span>X 1</span>
                              </li>
                            </ul>
                            <p>Saturday, December 21st 2024</p>
                          </div>
                          <div className="order">
                            <h4>Order #3143</h4>
                            <ul>
                              <li>
                                Almonds - 1 kg 900 $ <span>X 1</span>
                              </li>
                              <li>
                                Air tight plastic Containers 1.5 kg - 3 pcs 300
                                $ <span>X 1</span>
                              </li>
                              <li>
                                Amul Ghee - 1 ltr 540 $ <span>X 1</span>
                              </li>
                            </ul>
                            <p>Saturday, December 21st 2024</p>
                          </div>
                        </>
                      )}

                      {/* Content for Address */}
                      {activeTab === "Address" && (
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <thead className="thead-light">
                              <tr>
                                <th>Id</th>
                                <th>Title</th>
                                <th>Address</th>
                                <th>Landmark</th>
                                <th>Pincode</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>122</td>
                                <td>home/office</td>
                                <td>lorem sssswwww dwww</td>
                                <td>cb wwkwopp</td>
                                <td>50001</td>
                                <td>
                                  <i className="fa fa-edit"></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}

                      {/* Content for Reviews */}
                      {activeTab === "Reviews" && (
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <thead className="thead-light">
                              <tr>
                                <th>Id</th>
                                <th>From</th>
                                <th>On</th>
                                <th>Rating</th>
                                <th>Comment</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>122</td>
                                <td>Abde Faisal</td>
                                <td>2/1/2025</td>
                                <td>4</td>
                                <td>good and quick service</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminUserDetailPage;
